import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  AfterViewInit,
  ElementRef,
  ViewChild,
  Input,
  Output,
  EventEmitter,
  OnDestroy
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

declare var Datepair: any;
declare var $: any;

@Component({
  selector: 'pair-timepicker-v2',
  templateUrl: './pair-timepicker-v2.component.html',
  styleUrls: ['./pair-timepicker-v2.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PairTimepickerV2Component implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('pairTimePicker') pairTimePicker: ElementRef;
  timeContainer: HTMLElement;

  @Output() blurEvent: EventEmitter<string> = new EventEmitter();
  @Input() form: UntypedFormGroup;
  @Input() startControl: string = 'start';
  @Input() endControl: string = 'end';
  @Input() scrollId = '';

  datePair: any;
  _config: any = this.defualtTimePickerConfig;

  @Input()
  set config(_config: any) {
    this._config = Object.assign(this.defualtTimePickerConfig, _config);
  }

  get config() {
    return this._config;
  }

  get defualtTimePickerConfig() {
    return {
      showDuration: true,
      timeFormat: 'H:i',
      step: 15,
      lang: {
        mins: this.t.instant('CalendarEvents.Timepicker.mins'),
        hr: this.t.instant('CalendarEvents.Timepicker.hr'),
        hrs: this.t.instant('CalendarEvents.Timepicker.hrs')
      }
    };
  }

  get formatedDate() {
    return {
      start: this.form.get(this.startControl).value || null,
      end: this.form.get(this.endControl).value || null
    };
  }

  constructor(
    private fb: UntypedFormBuilder,
    private t: TranslateService
  ) {}

  ngOnInit(): void {
    this.createForm();
  }

  ngAfterViewInit() {
    this._initPairTimePicker();
  }

  ngOnDestroy(): void {
    const start: any = $(this.timeContainer.querySelectorAll('.start'));
    start.timepicker('hide');
  }

  private createForm() {
    if (!!this.form) {
      return;
    }
    this.form = this.fb.group({
      [this.startControl]: null,
      [this.endControl]: null
    });
  }

  private getTemplateValue(selector: string) {
    return (this.timeContainer.querySelector(selector) as HTMLInputElement).value;
  }

  private _initPairTimePicker() {
    this.timeContainer = this.pairTimePicker.nativeElement;

    const start: any = $(this.timeContainer.querySelectorAll('.start'));
    const end: any = $(this.timeContainer.querySelectorAll('.end'));

    //! Note: DON'T REMOVE IT
    //@ts-ignore
    const startPicker = start.timepicker(this.config);
    //@ts-ignore
    const endPicker = end.timepicker(this.config);
    this.datePair = new Datepair(this.timeContainer, { anchor: 'start' });

    $(this.timeContainer).on('rangeSelected', (range) => {
      this.form.get(this.startControl).setValue(this.getTemplateValue('.start'));
      this.form.get(this.endControl).setValue(this.getTemplateValue('.end'));
    });

    $(this.timeContainer).on('rangeIncomplete', (range) => {
      this.form.get(this.startControl).setValue(this.getTemplateValue('.start'));
      this.form.get(this.endControl).setValue(this.getTemplateValue('.end'));
    });

    start[0].addEventListener('keyup', this.updateOnEnter.bind(this, this.startControl));
    end[0].addEventListener('keyup', this.updateOnEnter.bind(this, this.endControl));

    if (!this.scrollId) return;

    const tracker = document.getElementById(this.scrollId);
    tracker.addEventListener('scroll', () => {
      start.timepicker('hide');
    });
  }

  updateOnEnter(controlname: string, event: any) {
    if (event.keyCode === 13) {
      event.preventDefault();
      this.updateControl(controlname);
      this.datePair.refresh();
    }
  }

  updateControl(controlName: string) {
    this.blurEvent.emit(controlName);
    this.form.get(controlName).markAsTouched();
    this.form.get(controlName).updateValueAndValidity();
  }
}
